import { useState, useEffect } from 'react';
import { fetchCRMObjectsById } from '../api/crmApi';

/**
 * Hook to fetch CRM objects by object ID
 * @param objectTypeId - The type ID of the CRM object
 * @param options - Additional options for the hook
 * @returns An object containing the fetched CRM objects, loading state, and any error
 */
const useFetchCRMObjects = (objectTypeId, disabled) => {
  const [data, setData] = useState(null);
  const [hasCRMObjects, setHasCRMObjects] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (!objectTypeId || disabled) {
      setHasCRMObjects(undefined);
      setData(null);
      setError(null);
      setIsLoading(false);
      return;
    }
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        var _result$objects;
        const result = await fetchCRMObjectsById(objectTypeId);
        setData(result);
        setHasCRMObjects(((_result$objects = result.objects) === null || _result$objects === void 0 ? void 0 : _result$objects.length) > 0);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData().catch(err => setError(err instanceof Error ? err : new Error('Failed to fetch CRM objects')));
  }, [disabled, objectTypeId]);
  return {
    data,
    isLoading,
    error,
    hasCRMObjects
  };
};
export default useFetchCRMObjects;